export const GA_EVENTS = {
    CAR_CARD_HOVER_ENDED_TIME: "hover_ended_time",
    CAR_CARD_HOVER_CARDS_SEEN: "hover_ended_image",

    CAR_CARD_HOVER_ENDED_TIME_DATA: {
        event: "desktop_clp",
        eventCategory: "car_card_hover",
        eventAction: "hover_ended_time"
    },
    CAR_CARD_HOVER_CARDS_SEEN_DATA: {
        event: "desktop_clp",
        eventCategory: "car_card_hover",
        eventAction: "hover_ended_image"
    },
    LOCATION_LINK_CLICKED: {
        eventAction: "location_link_clicked",
        eventCategory: "Cars24_listing_page",
        event: "custom_event"
    },
    SELLER_TYPE_TAG_CLICKED: {
        eventAction: "seller_type_tag_clicked",
        eventCategory: "Cars24_listing_page",
        event: "custom_event"
    },
    DESKTOP_CARD_GALLERY_SCROLLED: {
        eventCategory: "Cars24_listing_page",
        eventAction: "image_number",
        event: "desktop_card_gallery_scrolled"
    },
    DESKTOP_CARD_GALLERY_CLICKED: {
        eventCategory: "Cars24_listing_page",
        eventAction: "app_id",
        event: "desktop_card_gallery_clicked"
    },
    WISHLIST_DONE: {
        "event": "wishlist_done",
        "eventCategory": "wishlist",
        "eventAction": "clp/homepage/cdp",
        "eventLabel": "<app id>"
    },
    WISHLIST_REMOVED: {
        "event": "wishlist_removed",
        "eventCategory": "wishlist",
        "eventAction": "clp/homepage/cdp/wishlist_page",
        "eventLabel": "<app id>"
    }

};

export const AMPLITUDE_EVENT = {
    CAR_CARD_HOVER_ENDED: "car image hover ended"
};
